import { render } from "./FileDragUpload.vue?vue&type=template&id=56c6b913&scoped=true"
import script from "./FileDragUpload.vue?vue&type=script&lang=js"
export * from "./FileDragUpload.vue?vue&type=script&lang=js"

import "./FileDragUpload.vue?vue&type=style&index=0&id=56c6b913&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c6b913"]])

export default __exports__